module.exports = __webpack_public_path__ + "img/image-culture-1.7c1eccd3.png";